import { darken, getContrast, getLuminance, lighten } from "polished";

/** WCAG AA for normal-size text. */
export const MIN_TEXT_CONTRAST = 4.5;

/**
 * The nearest shade of `color` that meets AA contrast against `other`.
 *
 * Used to keep brand colours recognisable while staying readable: a light
 * orange behind white text becomes a deeper orange rather than switching the
 * text to black. Against a light `other` the colour is darkened, against a
 * dark one it's lightened. Colours that already pass come back unchanged, and
 * values polished can't parse (gradients, CSS variables) are returned as-is.
 */
export function accessibleShade(
  color: string,
  other: string = "#fff",
  minContrast: number = MIN_TEXT_CONTRAST,
): string {
  try {
    if (getContrast(color, other) >= minContrast) {
      return color;
    }

    const adjust = getLuminance(other) > 0.5 ? darken : lighten;

    for (let amount = 0.01; amount <= 1; amount += 0.01) {
      const shade = adjust(amount, color);
      if (getContrast(shade, other) >= minContrast) {
        return shade;
      }
    }

    return color;
  } catch {
    return color;
  }
}
